module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0005-9bec330a788364f3312915f048454d4f.jpg";